import { SESSION_FOR_CODE_HEADER_KEY } from 'utils/authSessionForCode/STORAGE_KEYS';
import { getSessionConfig } from 'utils/authSessionForCode/sessionConfig';

export function isSessionForCodeActive(headers?: { [name: string]: string }): boolean {
  if (headers && !!headers[SESSION_FOR_CODE_HEADER_KEY]) {
    return headers[SESSION_FOR_CODE_HEADER_KEY] === 'true';
  }
  return getSessionConfig().enabled;
}
